// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"70329849","321":"b96802c0","419":"bf0a1634","453":"746b4d30"}[chunkId] + ".chunk.js";
};